/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/VideoRecorder/_components/OverlayBottomPlayback.js
 * Created:       Wed Mar 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React from "react";

import { getImage } from "../../../../_utils";

export default function OverlayBottomPlayback({
  pauseRecording,
  overlayState,
  setOverlayState
}) {
  const playbackButtonMarkup = ( overlayState === "playback-complete" ) ?
    <></>:
    <div className={"gc__svg_button_large_container_playback"}>
      <button
        type={"button"}
        className={"gc__circle_button"}
        onClick={() => {
          pauseRecording();
          setOverlayState("playback-complete");
        }}
      >
        <img
          className={"gc__svg_filtered"}
          src={getImage("./icons/fontAwesome/pause-solid.svg")}
          alt="Pause button icon"
        />
      </button>
    </div>
  return (
    <div className={"gc__overlay_bottom_button_contianer"}>
      { playbackButtonMarkup }
    </div>
  );
}
